module.exports = __webpack_public_path__ + "static/aplicacion_movil-9c06fa79d0c7f5ec383d732899bfe38a.png";